import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authService from "./auth-service";
import { SetRefreshToken, SetToken, SetUser, readApiMessage } from "../../utils/helper/helper";

const initialState = {
  isLoading: false,
  isError: null,
  isSuccess: false,
  message: "",
  userData: [],
  singnalRConnection: false,
  authtoken: false,
};

export const LoginUser = createAsyncThunk(
  "login-user",
  async (userData, thunkAPI) => {
    try {
      const response = await authService.loginUserAPI(userData);

      // WEB-P1-161: THE SUCCESS TEST IS EXPLICIT NOW. loginUserAPI resolves on failure as well as
      // on success - see the header comment in auth-service.js - so this used to "work" only by
      // accident: `response.data` was undefined, destructuring it threw, and the throw is what
      // reached the catch below. Now that a failure carries a real body, the destructure would
      // succeed with undefined in every field and this would SetToken(undefined) and report the
      // sign-in as fulfilled. Guarded the same way Login.js:122 already guards it.
      //
      // Nothing dispatches this thunk today - Login.js calls loginUserAPI directly - but it is
      // exported and reachable, so it is fixed rather than left as a trap.
      if (!response?.data?.status) {
        return thunkAPI.rejectWithValue(readApiMessage(response));
      }

      const { token, refreshToken, email, fullName, userId, roleId } = response.data;
      SetToken(token);
      SetRefreshToken(refreshToken);
      SetUser({ email, fullName, userId, roleId });
      return response;
    } catch (error) {
      // Reached only by a genuine throw now - a bug in the block above, not an API failure.
      return thunkAPI.rejectWithValue(readApiMessage(error?.response));
    }
  }
);

const authReducer = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userData = action.payload;
    },

    setSignalRConnection: (state, action) => {
      if (!state.singnalRConnection) {
        state.singnalRConnection = action.payload.data;
      }
    },

    // #197: a boolean - whether there is a session for Context.js to connect the hub for. It used
    // to hold the token string, which changed on every renewal and reconnected the hub each time.
    setAuthToeken: (state, action) => {
      if (state.authtoken !== action.payload) {
        state.authtoken = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LoginUser.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(LoginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;

        state.userData = action.payload;

        state.message = action.payload;
      })
      .addCase(LoginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = "Something went wrong!";
        state.message = action.payload;
      });
  },
});

export const { setUserInfo, setSignalRConnection, setAuthToeken } =
  authReducer.actions;

export default authReducer.reducer;
